"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Presentation = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M14.359 1.765h-5.882V0.588a0.588 0.588 0 0 0-1.176 0v1.176H1.418a1.176 1.176 0 0 0-1.176 1.176v8.824a1.176 1.176 0 0 0 1.176 1.176h2.894l-1.589 1.984a0.588 0.588 0 1 0 0.919 0.735l2.246-2.718h4.141l2.176 2.72a0.588 0.588 0 1 0 0.919-0.736l-1.589-1.985h2.894a1.176 1.176 0 0 0 1.176-1.177V2.941a1.176 1.176 0 0 0-1.176-1.176zM5.883 9.412a0.588 0.588 0 0 1-1.177 0V7.647a0.588 0.588 0 0 1 1.177 0v1.765zm2.353 0a0.588 0.588 0 0 1-1.177 0V6.47a0.588 0.588 0 0 1 1.177 0v2.941zm2.353 0a0.588 0.588 0 0 1-1.177 0V5.294a0.588 0.588 0 0 1 1.177 0v4.118z",
  className: "fill"
}));
var _default = exports.default = Presentation;